enum MapMode {
    AUTO = 'auto',
    CUSTOM = 'custom',
}

export default MapMode